/* created by CoolGuy on 2018/12/13 */
import {observable,action} from 'mobx';
const redpackApi = require('../actions/redpack');

export default class RedPackStore {
    constructor(rootStore){
        this.rootStore = rootStore;
    }
    @observable showNormal = false;
    @action setNormal = (flag)=>{
        this.showNormal = typeof flag === 'boolean' ? flag : !this.showNormal;
    }
    @observable showVerifyModal = false;
    @observable verifyModalContent = {};
    @action setVerifyModal = (flag)=>{
        this.showVerifyModal = typeof flag === 'boolean' ? flag : !this.showVerifyModal;
    }
    @action setVerifyModalContent = (content)=>{
        this.verifyModalContent = content;
    }

    @observable showNotification = false;
    @action setNotification = (flag)=>{
        this.showNotification = typeof flag === 'boolean' ? flag : !this.showNotification;
    }

    @observable showSendModal = false;
    @action setSendModal = flag => {
        this.showSendModal = typeof flag === 'boolean' ? flag : !this.showSendModal;
    }
    sendSms = (phone,type='login')=>{
        return redpackApi.sendsms({phone,type});
    }
    bindPhone = (obj)=>{
        return redpackApi.bindphone(obj);
    }
    @observable redPackList = [];
    // 对于一些不方便拿到galleryid的，直接用第一次获取时的galleryid
    currentGalleryId = 0;
    getDetail = (galleryid)=>{
        if(!galleryid){
            galleryid = this.currentGalleryId;
        }
        this.currentGalleryId = galleryid;
        if(window.islogin) {
            return redpackApi.getdetail(galleryid).then(action(jsonData=>{
                const list = jsonData || [];
                this.redPackList = list.filter(one=>{
                    return !this.gotRedPackList().includes(one.id);
                });
                // console.log(this.redPackList.length);
                return jsonData;
            }));
        }
        return [];
    }
    @action removeOneRedPackList = (index = 0) => {
        const {length} = this.redPackList;
        if(index > length){
            return;
        }
        this.redPackList = [
            ...this.redPackList.slice(0,index),
            ...this.redPackList.slice(index+1),
        ]
    }
    @action addOneRedPack = ({content, postname, postphoto,id, posttype='now'}) => {
        this.redPackList.push({content, postname, postphoto,id,posttype});
    }
    @action setRedPackList = ([{content, postname, postphoto,id, posttype='now'}]) => {
        this.redPackList=[{content, postname, postphoto,id,posttype}];
    }
    @action removeAllRedPackList = ()=>{
        this.redPackList = []
    }
    @observable currentServerTime = 0;
    getServerTime = ()=>{
        return redpackApi.gettime().then(action(jsonData=>{
            const {timestamp} = jsonData;
            this.currentServerTime = timestamp;
            return timestamp;
        }));
    }
    getRedPack = (id)=>{
        return redpackApi.getredpack(id);
    }
    @observable notificationTime = 0;
    @action setNotificationTime = (time, useServerTime)=>{
        this.notificationTime = time - (useServerTime ? this.currentServerTime : 0);
        this.setNotification(true);
    }
    askRedPack = (id)=>{
        return redpackApi.askredpack(id);
    }
    askNGot = (history) => {
        const {uiStore} = this.rootStore;
        const {redPackList = [], askRedPack} = this;
        const one = redPackList[0];
        askRedPack(one.id).then((data)=>{
            //console.log(data);
            const {status} = data;
            // done  代表已领取过
            // forbidden 代表不可领取，包括：不在白名单，或者红包活动异常等情况
            // welcome 代表可领取
            switch (status) {
                case 'welcome': this.getTheRedPack(history);break;
                case 'wait':
                    uiStore.showAlert('当前红包状态异常');
                case 'forbidden':
                    uiStore.showAlert('当前红包不能被领取');
                    this.saveToGotRedPackList(one.id);
                    break;
                case 'done':
                // 下同
                case 'end':
                // 下同
                default:
                    // 因为某种情况反正已经领取了，直接就存进去了
                    this.saveToGotRedPackList(one.id);
                    history.push(`/redpack/${one.id}`);break;
            }


        })
    }
    getTheRedPack = (history)=>{
        const {uiStore} = this.rootStore;
        const {redPackList = [], getRedPack} = this;
        const one = redPackList[0];
        return getRedPack(one.id).then(()=>{
            uiStore.showToast({time:500,content:'领取成功'});
            this.saveToGotRedPackList(one.id);
            setTimeout(()=>{
                history.push(`/redpack/${one.id}`);
                this.removeOneRedPackList();
            }, 500)

        })
    }
    // 本地存储的已经领取的红包列表
    gotRedPackList = ()=>{
        const list = localStorage['gotRedPackList'];
        let jList;
        try{
            jList = JSON.parse(list);
        }catch (e) {
            jList = []
        }
        return jList;
    }

    saveToGotRedPackList = (id)=>{
        // localStorage['gotRedPackListTime'] 是最近一次已经点击的红包的时间
        const lastTime = localStorage['gotRedPackListTime'] || 0;
        const now = new Date().getTime();
        // 如果最后一次存入列表时间长于30天，清空列表
        if(now - lastTime > 30 * 24 * 3600 * 1000){
            delete localStorage['gotRedPackList'];
        }
        localStorage['gotRedPackListTime'] = now;
        const list = this.gotRedPackList();
        // 如果列表已经有这个ID了，那么就不需要存储了
        if(list.includes(id)){
            return;
        }
        //保证都是字符串，避免一些异常情况
        list.push(''+id);
        localStorage['gotRedPackList'] = JSON.stringify(list);
    }

    getOneRedPackDetail = (id,page)=>{
        return redpackApi.getredpackdetail(id,page)
    }

    getLocalLastForShowTime = (galleryId) => {
        const id = galleryId || this.currentGalleryId;
        // console.log(id,'getLocalLastForShowTime');
        let theList = null;
        try{
            theList = JSON.parse(localStorage['lastForShowTime']);
        }catch (e) {
            theList = null;
        }
        if(!Array.isArray(theList)) {
            return '';
        }
        const theOne = theList.find(one=>one.key==id);
        return theOne ? theOne.value : '';

    }
    // time为null表示删除当前项，否则会设定成其值（强制转换成Number）
    setLocalLastForShowTime = (galleryId,time) => {
        const id = galleryId || this.currentGalleryId;
        let theList = [];
        try{
            theList = JSON.parse(localStorage['lastForShowTime']);
        }catch (e) {

        }
        if(!theList){
            theList = [];
        }
        const theIndex = theList.findIndex(one=>one.key==id);
        if(theIndex === -1){
            theList.push({
                key:id,
                value: +time, //key 都保留是Number
            })
        }else{
            if(time === null){
                theList.splice(theIndex,1);
            }else{
                theList[theIndex].value = time;
            }

        }
        localStorage['lastForShowTime'] = JSON.stringify(theList);
    }

    preCreate = ({amount, galleryid}) => {
        return redpackApi.precreate({amount, galleryid})
    }

    create = ({ number, amount, type, content, tradeid, galleryid}) => {
        if(!tradeid){
            console.warn('tradeid is null',tradeid);
            return new Promise((resolve,reject)=>reject());
        }
        return redpackApi.create({ number, amount, type, content, tradeid, galleryid})
    }

    @action clearAll = ()=>{
        this.showNormal = false;
        this.showNotification = false;
        this.notificationTime = 0;
        this.currentServerTime = 0;
        this.redPackList = [];
    }

}



// WEBPACK FOOTER //
// ./src/store/RedPackStore.js